export enum ShareLessonTabs {
  SHARE_LINK = 'share-link',
  EXPORT_PDF = 'export-pdf',
  SHARE_WITH_STUDENTS = 'share-with-students',
}

export interface TabConfig {
  id: ShareLessonTabs;
  tabLabelKey: string;
  imageAssetPath: string;
  titleKey: string;
  bodyTextKey: string;
  linkTextKey?: string;
  linkUrlKey?: string;
  banner?: string;
}

export interface ShareLessonModalInnerProps {
  handleModalClose: () => void;
  isShareWithStudentsEnabled?: boolean;
  lessonShareUrl?: string;
  shareLessonWithStudentsUrl?: string;
  shareLessonsWithStudentsError?: Error;
  lessonId: string;
  loading?: boolean;
  onCopyTeacherShareUrl: () => void;
  onCopyStudentShareUrl: () => void;
  onPdfDownloadSuccess: () => void;
  exportToPdfDirect: (params: {
    lessonId: string;
    onSuccess?: () => void;
    onError?: (error: Error) => void;
    onLoadingChange?: (loading: boolean) => void;
  }) => void;
}
